import Model from "../classes/Model";
import Api from "../classes/api/ClientCard";
import ValidationError from "../classes/ValidationError";

export default class ClientCard extends Model {

    get id() {
        return this._id;
    }

    set clientId(value) {
        this._clientId = value;
    }
    get clientId() {
        return this._clientId;
    }

    set number(value) {
        this._number = value;
    }
    get number() {
        return this._number;
    }

    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }

    toRequest() {
        return {
            client_id: this.clientId,
            card_number: this.number,
        };
    }

    static toResponse(data) {
        return {
            id: data.id,
            clientId: data.client_id,
            number: data.card_number,
            createdAt: data.created_at,
            createdBy: data.created_by,
        };
    }

    add() {
        let request = this.toRequest();
        return Api.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            let newCard = new ClientCard({id: data.id});
            newCard.clientId = request.client_id;
            newCard.number = request.card_number;
            newCard.createdAt = (new Date()).getTime() / 1000;
            return newCard;
        });
    }

}
